import { createSlice } from "@reduxjs/toolkit";

const bannerDraftSlice = createSlice({
  name: "bannerDraft",
  initialState: { draft: null },
  reducers: {
    saveBannerDraft: (state, action) => {
      const { image, imagePreview, ...rest } = action.payload;
      state.draft = {
        ...rest,
        // only persist remote URLs, not blob: URLs (File objects can't serialize)
        imagePreview: typeof imagePreview === "string" && imagePreview.startsWith("http")
          ? imagePreview
          : null,
      };
    },
    clearBannerDraft: (state) => {
      state.draft = null;
    },
  },
});

export const { saveBannerDraft, clearBannerDraft } = bannerDraftSlice.actions;
export default bannerDraftSlice.reducer;
